import { collect } from 'collect.js';
import { DeliveryProvider } from '../exports/Constants';

/**
 * Pure service-provider regional-config predicates. See
 * tests/services/tenant/serviceProviderConfig.test.js.
 */

/**
 * Whether the service provider supports any external (non-standalone) delivery
 * provider — i.e. delivery handled by a third party rather than in-house.
 */
export function hasExternalDeliveryProviders(supportedProviders) {
  return collect(supportedProviders)
    .filter((item) => item !== DeliveryProvider.Standalone)
    .isNotEmpty();
}
